import React from 'react';

import { IntlShape } from 'react-intl';

import { ServiceMode } from 'state/order';

interface IGetOrderConfirmationHeader {
  userName: string;
  needConfirm: boolean | undefined;
  formatMessage: IntlShape['formatMessage'];
}

interface IGetOrderConfirmationInstructions {
  userName: string;
  serviceMode: ServiceMode;
  needConfirm: boolean | undefined;
  formatMessage: IntlShape['formatMessage'];
  imHere: React.ReactNode;
}

export const getOrderConfirmationHeader = ({
  userName,
  needConfirm,
  formatMessage,
}: IGetOrderConfirmationHeader): string => {
  const key = needConfirm ? 'orderHasBeenSaved' : 'orderIsBeingMadeYourWay';
  return formatMessage({ id: key }, { userName });
};

export const getOrderConfirmationInstructions = ({
  userName,
  serviceMode,
  needConfirm,
  formatMessage,
  imHere,
}: IGetOrderConfirmationInstructions): string | React.ReactNode | null => {
  let instructions;

  switch (serviceMode) {
    case ServiceMode.EAT_IN:
      instructions = needConfirm
        ? 'orderConfirmationInstructionsPreConfirmed'
        : 'orderConfirmationInstructionsConfirmed';
      break;
    case ServiceMode.TAKEOUT:
      instructions = 'orderConfirmationInstructionsTakeOut';
      break;
    case ServiceMode.DELIVERY:
      instructions = 'orderConfirmationInstructionsDelivery';
      break;
    case ServiceMode.CURBSIDE:
      instructions = needConfirm
        ? 'orderConfirmationInstructionsPreConfirmed'
        : 'orderConfirmationInstructionsConfirmedCurbside';
      break;
    case ServiceMode.DRIVE_THRU:
      instructions = 'orderConfirmationInstructionsDriveThru';
      break;
    default:
      instructions = '';
  }

  return instructions ? formatMessage({ id: instructions }, { userName, imHere }) : null;
};
